import { getDeepCopiedObject as n } from "./get-deep-copied-object.mjs";
const f = (o, e) => {
  var r;
  const { common: m, ...s } = n(e), t = { ...s, ...((r = o.errors) == null ? void 0 : r.fields) || {} };
  return {
    common: o.errors.common ?? m,
    ...t
  };
};
export {
  f as parseErrors
};
